import { Axios } from 'axios';
import AxiosClient from '../_setup/AxiosClient';
import { COMMON, ADMIN } from '../apiEndpoints';

const ApplicantDetailsServices = {
  getApplicantDetails: (id: string) => AxiosClient.get(`${COMMON.APPLICANT_PROFILE}${id}`),
  rejectApplication: (id: string, payload: any) => AxiosClient.put(`${ADMIN.APPLICATION.REJECT}${id}`, payload),
  updateApplicantDetails: (id: string, data: any) => AxiosClient.put(`${ADMIN.APPLICATION.UPDATE}${id}`, data),
  confirmMembership: (id: string) => AxiosClient.put(`${ADMIN.APPLICATION.CONFIRM_MEMBERSHIP}${id}`),
  addOfflinePaymentDetails: (id: string, payload: any) => AxiosClient.put(`${ADMIN.PAYMENT.RECORD_OFFLINE_PAYMENT}${id}`, payload),
  refundOfflinePaymentDetails: (payload: any) => AxiosClient.post(ADMIN.PAYMENT.OFFLINE_REFUND, payload),
  approveProposerSeconder: (id: string) => AxiosClient.put(`${ADMIN.APPLICATION.APPROVE}${id}`, {
    ratification_status: 'ACCEPTED',
  }),
};

export default ApplicantDetailsServices;
